import { ROUTES } from 'constants/routes';
import { Notification } from 'models';
import NotificationCoin from 'assets/icons/NotificationCoin';
import WelcomeVoucherCircle from 'assets/icons/WelcomeVoucherCircle';
import SurprisePerkQuestion from 'assets/icons/SurprisePerkQuestion';
import PercentOffFoodVoucherCircle from 'assets/icons/PercentOffFoodPromotionCircle';
import StaticGiftBox from 'assets/icons/StaticGiftBox';
import { pushAnalyticsEvent } from 'helpers/analytics';
import { ReferAndEarnPizza } from 'assets/icons/ReferAndEarnPizza';
import ZizziPlus30Point from 'assets/icons/ZizziPlus30Point';
import Jet2holidays from 'assets/icons/Jet2holidays';
import WinASlice from 'assets/icons/WinASlice';
import AddToHomeScreenIcon from 'assets/icons/AddToHomeScreenIcon';
import IosShareIcon from 'assets/images/graphic-ios-share-icon.svg';
import InstallNotificationMoreIcon from 'assets/images/graphic-more-icon.svg';
import HalfPricePromotion from 'assets/icons/HalfPricePromotion';
import Zizzi25thBirthdayCircle from 'assets/icons/Zizzi25thBirthdayCircle';

export const offerInWalletNotification: Notification = {
  priority: 2,
  id: 'offer-in-wallet',
  isVisible: false,
  title: '',
  callToAction: 'View Perk',
  description: '',
  image: '',
  path: ROUTES.PERKZ_WALLET,
};

export const saleNotification: Notification = {
  priority: 1,
  id: 'sale',
  isVisible: false,
  title: 'Bambini Perkz Sale now on!',
  description:
    'Save your Zs and snap up an amazing 50% off Bambini Menu perkz this summer! Sale ends 12.08.24 at 10AM.',
  image: HalfPricePromotion,
  callToAction: 'Visit Perkz Store',
  path: ROUTES.PERKZ_STORE,
};

export const welcomeNotification: Notification = {
  priority: 3,
  id: 'welcome',
  isVisible: false,
  title: 'Welcome to the club!',
  description: 'Visit the “Perkz Wallet” page to view and redeem your delicious freebies.',
  image: WelcomeVoucherCircle,
  path: ROUTES.PERKZ_WALLET,
};

export const welcomeBonusNotification: Notification = {
  priority: 4,
  id: 'welcome-bonus',
  isVisible: false,
  title: "Surprise! We've sent you 30 Bonus Zs",
  callToAction: 'Swap them for tasty Perkz',
  description: "As thanks for completing your 1st visit, we've added 30 extra Zs to your balance!",
  image: ZizziPlus30Point,
  path: ROUTES.PERKZ_STORE,
};

export const surpriseNotification: Notification = {
  priority: 5,
  id: 'surprise',
  isVisible: false,
  title: 'Your Surprise Perk is waiting...',
  description: 'Click below and see what you have unlocked!',
  image: SurprisePerkQuestion,
  path: ROUTES.SURPRISE_PERK,
};

export const birthdayNotification: Notification = {
  priority: 6,
  id: 'birthday',
  isVisible: false,
  title: `You've received a Birthday Perk!`,
  description:
    'Celebrate with a little something from us. Visit your “Perkz Wallet” to view your Birthday Perk.',
  image: StaticGiftBox,
  path: '',
};

export const referralBonusNotification: Notification = {
  priority: 7,
  id: 'referral-bonus',
  isVisible: false,
  title: `Thanks for referring us! We have added 50Zs to your balance`,
  description: 'Find out what delicious perkz you could swap all your Zs for!',
  image: NotificationCoin,
  callToAction: 'Go to Perkz Store',
  path: ROUTES.PERKZ_STORE,
};

export const referAndEarnNotification: Notification = {
  priority: 8,
  id: 'refer',
  isVisible: true,
  title: 'Earn 50 Zs when you refer a friend!',
  description: 'Invite a friend to the club and earn 50 Zs when they complete their first visit!',
  image: ReferAndEarnPizza,
  callToAction: 'Learn more',
  path: ROUTES.REFER_A_FRIEND,
  onClick: () => pushAnalyticsEvent({ event: 'clickReferAFriend', title: 'Notification Centre' }),
};

export const installNotification: Notification = {
  priority: 9,
  id: 'install',
  isVisible: false,
  title: `Want to add the Zillionaires' Club app to your home screen?`,
  description: `Simply tap ![Add to home screen](${IosShareIcon}#IosShareIcon) then 'Add to Home screen'`,
  image: AddToHomeScreenIcon,
  callToAction: 'Learn more',
  path: ROUTES.HOW_IT_WORKS,
};

export const installWithPromptNotification: Notification = {
  ...installNotification,
  description: `Simply tap the button below, or click on ![Add to home screen](${InstallNotificationMoreIcon}#MoreIcon) in the top right followed by 'Add to Home screen'`,
  callToAction: 'Add to Home Screen',
  path: '',
};

export const percentageOffFoodPromotionNotification: Notification = {
  priority: 10,
  id: 'percent-off-food',
  isVisible: false,
  title: '25% off food ends this week!',
  callToAction: 'See Perkz Wallet',
  description: 'Be one of the first to try our new Spring dishes and save ££.',
  image: PercentOffFoodVoucherCircle,
  path: ROUTES.PERKZ_WALLET,
};

export const amountOffFoodPromotionNotification: Notification = {
  priority: 11,
  id: 'amount-off-food',
  isVisible: false,
  title: 'Get £25 off for our 25th birthday!',
  callToAction: 'View Perk',
  description:
    'Celebrate our 25th birthday with £25 off when you spend £65!* Excludes Saturdays. Ends 02.05.24.',
  image: Zizzi25thBirthdayCircle,
  path: ROUTES.PERKZ_WALLET,
};

export const winASliceNotification: Notification = {
  priority: 12,
  id: 'win-a-slice',
  isVisible: false,
  title: 'Cars, holidays & more could be won!',
  description: `Visit Zizzi & receive a code to try crack the safe and win exciting prizes. Make sure you’re **[opted-in to emails](/profile/edit)** to receive the code.`,
  image: WinASlice,
  callToAction: 'Learn more',
  path: ROUTES.WIN_A_SLICE,
  onClick: () => pushAnalyticsEvent({ event: 'winASlice', title: 'Notification Centre' }),
};

export const jet2holidaysNotification: Notification = {
  priority: 13,
  id: 'jet2holidays',
  isVisible: false,
  title: 'WIN a holiday to Sicily with Jet2holidays AND a £100 Zizzi voucher!',
  callToAction: 'Enter here',
  description: 'Plus 10x £50 Zizzi vouchers up for grabs. T&Cs apply.',
  image: Jet2holidays,
  path: 'https://www.jet2holidays.com/zizzi?utm_source=zizzi&utm_medium=referral&utm_campaign=zizzi&utm_term=zillionaires_web_app&utm_content=partner_channel',
};

export const availableNotifications: Notification[] = [
  saleNotification,
  percentageOffFoodPromotionNotification,
  welcomeBonusNotification,
  surpriseNotification,
  winASliceNotification,
  installNotification,
  birthdayNotification,
  welcomeNotification,
  referralBonusNotification,
  referAndEarnNotification,
  jet2holidaysNotification,
  amountOffFoodPromotionNotification,
  offerInWalletNotification,
];
